<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">
            <el-form-item label="ICCID：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getWillExpireList($event)" clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" clearable></el-input>
            </el-form-item>
            <el-form-item label="时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getWillExpireList($event)">搜索查询</el-button>
                <el-button type="primary"  @click="importCardVisible = true">导入</el-button>
                <el-button type="success"  @click="exportAllHandle">导出</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border height="611">
            <el-table-column label="ICCID号" width="180px">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号码" width="130px"></el-table-column>
            <el-table-column prop="remainsDay" label="过期天数 " width="80px"></el-table-column>
            <el-table-column prop="agentPathName" label="代理商层级" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="140px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="activationrTime" label="激活时间" width="140px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="expireTime" label="到期时间" width="140px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="stateName" label="卡状态"  width="80px"></el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

         <!-- 导入弹窗 -->
        <el-dialog title="批量导入即将过期卡" :visible.sync="importCardVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" :rules="importCardRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/expiringSim/delete')" :headers="setHeader()" :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success = "handleSuccess" :file-list="fileList">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle()">导出模板</el-button>
                    </el-upload>                        
                </el-form-item>  
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle">确 定</el-button>
            </div> 
        </el-dialog>         
    </div>
</template>

<script>
import {getHasExpired} from '@/api/endtime.js'
import common from '@/utils/common.js'
export default {
    data(){    
        var checkImportFile = (rule, value, callback) => {
            var files = this.$refs.upload.uploadFiles
            var len = files.length;
            if(len > 0){
                var extName = files[0].name.split('.')[1].toLowerCase();
                if(extName != 'xls' && extName != 'xlsx'){
                    return callback(new Error('请选择要导入的Excel文件'));
                }else{
                    callback();
                }
            }else{
                return callback(new Error('请选择要导入的Excel文件'))
            }           
        }     
        return {
            searchForm: {
                time: null,
                iccid: null,
                intoNo: null
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            supplierOption: [],
            simHandleRules: {
                agentId: [{required: true, message: '请选择代理商', trigger: 'change'}]
            },
            importCardVisible: false,
            importCardRules: {
                uploadExcel: [{required: true, validator: checkImportFile}],
                states: [{required: true, message: '请选择卡状态', trigger: 'change'}]
            },
            importCardForm:{
                states: null,
            },      
            fileList: [],     
        }
    },
    methods: {
        cancel(){
            this.fileList.pop();
            this.importCardForm.states = null;
            this.importCardVisible = false;
        },
        //批量修改卡状态  excel导入
        handleChange(file, fileList){
            if(fileList.length > 1){
                fileList.splice(0,1);
            }
            this.$refs.importCardForm.fields[0].clearValidate();
            console.log(this.fileList);
        },     
        handleSuccess(res){
            if(res.code == 200){
                this.getListHandler();
                
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
            this.importCardVisible = false;
        },   

        sureImportCardHandle(){
            this.$refs.importCardForm.validate(valid => {
                if(valid){
                    this.$refs.upload.submit();   //号段批量导入
                }
            })           
        },



        getWillExpireList($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            getHasExpired(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'endTimeMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('detailMenu').click();
        },
        exportAdminEndTimeSimHandle(){//导出excel文件
            var data = JSON.parse(JSON.stringify(this.searchForm));
            data.token = localStorage.getItem('token');
            this.exportExcel('/excels/admin/expire/sim/all', data);
            this.$message.success('下载中……');
        },
        formatDate(){
            this.searchForm.remainExpireDate = this.searchForm.remainExpireDate.replace(/\D/g,'');
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getWillExpireList();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getWillExpireList();
        },
        exportHandle(){
            this.exportExcel('/download/expiringSim/template', {});
            this.$message.success('下载中……');
        },
        exportAllHandle() {
            this.exportExcel('/download/sim/alreadyExpire', {});
            this.$message.success('下载中……');
        }       
    },
    created () {
        this.getWillExpireList();
        common.getSupplierOptsCom(this, 'supplierOption')
    }
}
</script>

<style lang="scss" scoped>

    .input-defind{
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        width: 100%;
    }

</style>

